import queryString from 'query-string'
import api from '../api'
import apiV2 from '.'

export const usersApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getUsersV2: builder.query({
      query: ({ domainId, eventId, page, pageSize, filters, headers, orderBy }) => ({
        url: `/users?${queryString.stringify({
          page,
          pageSize,
          domainId,
          eventId,
        })}`,
        method: 'POST',
        body: { filters, headers, orderBy },
      }),
      transformResponse: response => response.data,
      providesTags: ['USERS', 'PARTICIPATION'],
    }),
    getMyAssociates: builder.query({
      query: ({ domainId, eventId }) => ({
        url: `/domains/${domainId}/events/${eventId}/users/associates/me`,
        method: 'GET',
      }),
      transformResponse: response => response.data.users,
      providesTags: ['USERS', 'EMPLOYEES'],
    }),
    getMe: builder.query({
      query: ({ domainId }) => ({
        url: `/domains/${domainId}/users/me`,
        method: 'GET',
      }),
      transformResponse: response => response.data.me,
      providesTags: ['USER_PREF', 'USERS'],
    }),
    getUsersSettings: builder.query({
      query: ({ domainId, eventId, settingsId }) => ({
        url: `/users/settings?${queryString.stringify({ domainId, eventId, settingsId })}`,
        method: 'GET',
      }),
      transformResponse: response => response.data.settings,
    }),
    createUsersExport: builder.query({
      query: ({ domainId, eventId, filters, headers, withShortLabel }) => ({
        url: `/domains/${domainId}/users/export?${queryString.stringify({ domainId, eventId })}`,
        method: 'POST',
        body: { filters, headers, withShortLabel },
      }),
      transformResponse: response => response.data.fileUrl,
      providesTags: ['USERS', 'PARTICIPATION'],
    }),
    updateUser: builder.mutation({
      query: ({ domainId, userId, user }) => ({
        url: `/domains/${domainId}/users/${userId}`,
        method: 'PUT',
        body: { user },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          // invalider Users dans l'autre API
          dispatch(api.util.invalidateTags(['EVENT_USER', 'User']))
        } catch {
          /* no-op */
        }
      },
      invalidatesTags: ['USERS'],
    }),
  }),
})

export const {
  useGetMyAssociatesQuery,
  useLazyGetMyAssociatesQuery,
  useGetMeQuery,
  useGetUsersV2Query,
  useGetUsersSettingsQuery,
  useLazyGetUsersV2Query,
  useCreateUsersExportQuery,
  useLazyCreateUsersExportQuery,
  useUpdateUserMutation,
  useLazyGetMeQuery,
} = usersApi
